"use client";

import Dragger from './Dragger';
import InternalUpload, { LIST_IGNORE } from './Upload';
const Upload = InternalUpload;
Upload.Dragger = Dragger;
Upload.LIST_IGNORE = LIST_IGNORE;
export default Upload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/upload/index.js
// module id = 4148
// module chunks = 0